import React, { useEffect, useState } from 'react';
import { Button, Form, FormGroup } from 'semantic';
import { useTranslation } from 'react-i18next';
import { EditCustomerGroupModal } from './EditCustomerGroupModal';
import CardStyleRadioButton from 'components/form-fields/CardStyleRadioButton';
import { request } from 'utils/api';
import { SearchDropdown } from 'components';
import { Account } from 'types/account';

type Props = {
  values: string[];
  onChange?: (values: string[]) => void;
};

const CustomerGroupSelection: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const [isAllSelected, setIsAllSelected] = useState(!props.values?.length);
  const [selectedCustomerGroupIds, setSelectedCustomerGroupIds] = useState<
    string[]
  >(props.values);

  useEffect(() => {
    if (isAllSelected) {
      props.onChange?.([]);
    } else if (selectedCustomerGroupIds.length > 0) {
      props.onChange?.(selectedCustomerGroupIds);
    }
  }, [isAllSelected, selectedCustomerGroupIds]);

  const handleModeChange = (isAll: boolean) => {
    if (isAll !== isAllSelected) {
      setSelectedCustomerGroupIds([]);
    }
    setIsAllSelected(isAll);
  };

  return (
    <>
      <FormGroup style={{ marginLeft: '0', marginRight: '0' }}>
        <CardStyleRadioButton
          isSelected={isAllSelected}
          onClick={() => handleModeChange(true)}
          text={t(
            'chargingPolicy.pricing.customerGroupSelectionEveryone',
            'Everyone'
          )}
        />
        <CardStyleRadioButton
          isSelected={!isAllSelected}
          onClick={() => handleModeChange(false)}
          text={t(
            'chargingPolicy.pricing.customerGroupSelectionSpecific',
            'Customer Groups'
          )}
        />
      </FormGroup>
      {!isAllSelected && (
        <>
          <Form.Field required>
            <label>
              {t(
                'chargingPolicy.pricing.selectCustomerGroups',
                'Select Customer Groups'
              )}
            </label>
            <SearchDropdown
              value={props.values}
              multiple
              onChange={(
                e: React.ChangeEvent<HTMLInputElement>,
                { value }: { value: string[] }
              ) => {
                setSelectedCustomerGroupIds(value as string[]);
              }}
              onDataNeeded={(body: Object) => {
                return request<{ data: Account[] }>({
                  path: '/1/customer-groups/search',
                  method: 'POST',
                  body: body,
                });
              }}
            />
          </Form.Field>
          <EditCustomerGroupModal
            trigger={
              <Button
                basic
                icon="plus"
                style={{ marginLeft: '0' }}
                content={t(
                  'chargingPolicy.pricing.addCustomerGroup',
                  'New Customer Group'
                )}
              />
            }
            mode="create"
            afterSubmit={(createdId) => {
              setSelectedCustomerGroupIds((prev) => [...prev, createdId!]);
            }}
          />
        </>
      )}
    </>
  );
};

export default CustomerGroupSelection;
